import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as CFormsSearch from '@core/custom-forms/models/field-search.model';
import * as Objects from '@core/objects';

interface CustomFormsAvailableFilters {
    status: CFormsSearch.SearchAvailableFilters;
    labels: CFormsSearch.SearchAvailableFilters;
}

interface CustomFormsStarting {
    initialized: boolean;
    labels_ready: boolean;
    status_ready: boolean;
    categories_ready: boolean;
    users_ready: boolean;
}

interface CustomFormSearchData {
    search: CustomFormsSearch;
    search_query_params: CFormsSearch.SearchQueryParams;
    artwork_results: CustomFormsResults;
}


export interface CustomForms {
    starting: CustomFormsStarting;
    available_filters:  CustomFormsAvailableFilters;
    categories: Array<Objects.LabelsGroup>;
    users: Array<Objects.User>;

    searches: { [uuid: string]: CustomFormSearchData };
}

interface CustomFormsSearch {
    term: string;
    sort: string;
    limit: number;
    filters: Array<CFormsSearch.SearchAppliedFilter>;
}

interface CustomFormsResults {
    next_page: number;
    // final: boolean;
    items: Array<Objects.Version>;
    status: number;
}


export const initialState: CustomForms = {
    starting: {
        initialized: false,
        labels_ready: false,
        status_ready: false,
        categories_ready: false,
        users_ready: false
    },
    available_filters : {
        status: {
            key: "status",
            items: []
        },
        labels: {
            key: "label",
            items: []
        }
    },
    categories: [],
    users: [],
    searches: {}
};

export const initialSearchState: CustomFormSearchData = {
    search: {
        term: "",
        sort: "",
        limit: 10,
        filters: [],
    },
    search_query_params: null,
    artwork_results: {
        next_page: 1,
        status: CFormsSearch.SearchHttpStatus.INITIAL,
        items: []
    }
};


const customFormsFeatureSelector = createFeatureSelector('custom_forms');

// Selectors
export const customFormsSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state
);

export const customFormsStartingCategoriesSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.starting.categories_ready
);


export const customFormsFiltersInitializedSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.starting.labels_ready && state.starting.status_ready
);

export const customFormsLabelsFiltersInitializedSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.starting.labels_ready
);

export const customFormsStartingUsersSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.starting.users_ready
);

export const availableFiltersSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.available_filters
);

export const availableFilterLabelsSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.available_filters.labels
);

export const availableFilterStatusSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.available_filters.status
);

export const categoriesSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.categories
);

export const usersSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.users
);

export const artworkResultsSelector = (uuid: string) => createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.searches[uuid]?.artwork_results?.items || []
);

export const searchesSelector = createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.searches
);

export const resultStatusSelector = (uuid: string) => createSelector(
    customFormsFeatureSelector,
    (state: CustomForms) => state.searches[uuid]?.artwork_results?.status || CFormsSearch.SearchHttpStatus.INITIAL
);